import * as React from "react";

const ModalBackdrop = React.lazy(() => import("./ModalBackdrop"));
const JustAddedToCart = React.lazy(() => import("../AddToCart/JustAdded"));

interface JustAddedInfo {
  name: string;
  imgURL: string;
  price: string;
}

const CartDrawer: React.FC = () => {
  const [modalIsVisible, setModalIsVisible] = React.useState(false);
  const [mostRecentProductInfo, setMostRecentProductInfo] = React.useState({
    name: "",
    imgURL: "",
    price: "",
  });

  // Show Overlay and Drawer Modal after 'Add to Cart' button is clicked
  React.useEffect(() => {
    const showLastAddedInModal = (event: CustomEvent) => {
      const { productName, productImageSrc, productPrice } = event.detail;

      const justAddedProductInfo: JustAddedInfo = {
        name: productName,
        imgURL: productImageSrc,
        price: productPrice,
      };
      setMostRecentProductInfo(justAddedProductInfo);
      setModalIsVisible(true);
    };

    document.addEventListener("addToCart", showLastAddedInModal);

    return () => {
      document.removeEventListener("addToCart", showLastAddedInModal);
    };
  });

  // Close Overlay and Drawer Modal when pressing 'Escape' button
  React.useEffect(() => {
    const closeModalWithEscapeBtn = (e: KeyboardEvent) => {
      if (modalIsVisible && e.code === "Escape") {
        setModalIsVisible(false);
      }
    };

    window.addEventListener("keydown", closeModalWithEscapeBtn);

    return () => {
      window.removeEventListener("keydown", closeModalWithEscapeBtn);
    };
  });

  return (
    <>
      <ModalBackdrop
        open={modalIsVisible}
        onClose={() => setModalIsVisible(false)}
      >
        <JustAddedToCart
          handleClick={() => setModalIsVisible(false)}
          justAdded={mostRecentProductInfo}
        />
      </ModalBackdrop>
    </>
  );
};

export default CartDrawer;
